var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTelegramWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 0C63.6437 0 82 18.3563 82 41C82 63.6437 63.6437 82 41 82C18.3563 82 0 63.6437 0 41C0 18.3563 18.3563 0 41 0ZM41 15C26.6406 15 15 26.6406 15 41C15 55.3594 26.6406 67 41 67C55.3594 67 67 55.3594 67 41C67 26.6406 55.3594 15 41 15ZM51.9639 30.7959C53.1077 30.2767 54.2111 31.0707 53.7744 32.8213L49.5098 52.9199C49.2119 54.3481 48.349 54.69 47.1533 54.0303L40.6562 49.2305L37.5332 52.2666C37.1704 52.6193 36.8833 52.917 36.2334 52.917L36.6758 46.2881L48.7314 35.4092C49.2606 34.9396 48.6165 34.7108 47.9141 35.1367L33.0342 44.5234L26.6074 42.5176C25.2196 42.0926 25.2097 41.1388 26.9189 40.4531L51.9639 30.7959Z",
    fill: "#DAD7DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTelegramWhite);
export default __webpack_public_path__ + "static/media/logoTelegramWhite.39e717e0453d74eb9c7c102f630fe251.svg";
export { ForwardRef as ReactComponent };